export default __webpack_public_path__ + "static/media/icon-tooltip.f3df254a.svg";